import { Grid } from '@/common/grid/Grid';
import { useModuleFromRoute } from '@/common/hooks/route/useModuleFromRoute';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { useEffect, useRef, useState } from 'react';

// TODO: When count is loading, then '-'
export const AggCalcTrxLookupViewerGrid = ({
  viewerReqParam,
  entity,
  onOppositeSide,
  incMode,
  side,
  onExportReqChange,
}) => {
  const rsrc = useRsrc();
  const module = useModuleFromRoute();

  const gridRef = useRef();

  const [fieldDefs, setFieldDefs] = useState();
  const [incDataSrc, setIncDataSrc] = useState();

  useEffect(() => {
    rsrc.viewerFieldDefs(module, 'AGG_CALC_TRX_LOOKUP_VIEWER_PLUGIN', viewerReqParam, entity).then((fieldDefs) => {
      setFieldDefs(fieldDefs);
    });

    rsrc
      .rows('gp', 'INC_DATA_SRC', { expr: ExprUtils.whereParams('id', viewerReqParam.data.incDataSrcId) })
      .then((dataSrc) => {
        setIncDataSrc(dataSrc[0]);
      });
  }, []);

  useEffect(() => {
    if (!gridRef.current) return;
    onGridReady();
  }, [onOppositeSide]);

  const onGridReady = (params) => {
    const dataSource = {
      getRows: (params) => {
        const filter = {
          filterType: 'set',
          values: ['Y'],
        };

        const filterModel = {};
        filterModel[`_${incDataSrc.code.toLowerCase()}`] = filter;

        const trxSelPeriod = viewerReqParam.data.trxSelPeriod;
        if (trxSelPeriod) {
          filterModel[`_${trxSelPeriod.toLowerCase()}`] = filter;
        }

        const combinedFilterModel = incMode ? { ...params.filterModel, ...filterModel } : params.filterModel;

        const expr = ExprUtils.filterModelToExpr(combinedFilterModel, fieldDefs);

        const reqParam = {
          ...viewerReqParam,
          startRow: params.startRow,
          endRow: params.endRow,
          onOppositeSide,
          expr,
        };

        if (onExportReqChange) {
          const sideUpdate =
            side === 'left' ?
              { leftViewerReqParam: reqParam, leftFieldDefs: fieldDefs }
            : { rightViewerReqParam: reqParam, rightFieldDefs: fieldDefs };
          onExportReqChange(sideUpdate);
        }

        rsrc.viewerRows(module, 'AGG_CALC_TRX_LOOKUP_VIEWER_PLUGIN', reqParam, entity).then((res) => {
          if (gridRef.current) {
            gridRef.current.onGridSuccess(res, params);
            gridRef.current.resize();
          }
        });

        // Count and totals depend only on the filter, not the scrolled page, so fetch them once
        // per filter (first block) instead of on every infinite-scroll block.
        if (params.startRow === 0) {
          rsrc.viewerSummary(module, 'AGG_CALC_TRX_LOOKUP_VIEWER_PLUGIN', reqParam, entity).then((summary) => {
            if (gridRef.current) {
              gridRef.current.setRowCount(summary.count);
              gridRef.current.setTotalsRow(summary.totals);
            }
          });
        }
      },
    };

    gridRef.current.setDataSource(dataSource);
  };

  return (
    fieldDefs && (
      <Grid key={`${incMode}-${incDataSrc}`} ref={gridRef} gridOptions={{ fieldDefs }} events={{ onGridReady }} />
    )
  );
};
